import { CheckboxSelector, CheckboxSelectorInner } from '@Knowledge-OTP/znk-ui-components'
import React from 'react'
import useTranslation from '../../../i18n/useTranslation'
import FilterBadge from '../../../common/FilterBadge'

const GraduationFilter = (props) => {
  const { graduationFilters, setGraduationFilters, graduationDates, useInner = false } = props
  const { translate } = useTranslation()
  const graduationOptions = graduationDates?.map((item) => {
    const yearGrad = parseInt(item.replace('‘', '').split(' ').slice(-1))
    return { name: 'Class of ´' + item, id: yearGrad }
  })
  const checkboxSelectorProps = {
    setDataFilters: setGraduationFilters,
    direction: 'bottomCenter',
    dataFilters: graduationFilters,
    typeFilter: 'statuses',
    data: graduationOptions,
    strings: {
      viewAll: translate('filters.plans.viewAll'),
      buttonCancel: translate('filters.plans.buttonCancel'),
      buttonApply: translate('filters.plans.buttonApply'),
      search: translate('filters.plans.search')
    }
  }
  return (
    useInner ? 
    <CheckboxSelectorInner style={{maxWidth: 'auto'}} {...checkboxSelectorProps}/> :
    <CheckboxSelector {...checkboxSelectorProps}>
      <FilterBadge
        title='Class'
        options={graduationOptions}
        selectedIds={graduationFilters}
        onClearFilters={() => setGraduationFilters([])}
      />
    </CheckboxSelector>
  )
}
export default GraduationFilter
